import Localization from 'lib/localization';

export default {
    lxFooterPageLinksGeneral() {
        return Localization.get('badoo_safety_center@footer.page_links.general');
    },
    lxFooterPageLinksAbout() {
        return Localization.get('badoo_safety_center@footer.page_links.about');
    },
    lxFooterPageLinksCareers() {
        return Localization.get('badoo_safety_center@footer.page_links.careers');
    },
    lxFooterPageLinksBlog() {
        return Localization.get('badoo_safety_center@footer.page_links.blog');
    },

    lxFooterCtaCreateAccount() {
        return Localization.get('badoo_safety_center@footer.cta.create_account');
    },

    lxFooterSocialLinksFollow() {
        return Localization.get('badoo_safety_center@footer.social_links.follow');
    },
    lxFooterSocialLinksInstagram() {
        return Localization.get('badoo_safety_center@footer.social_links.instagram');
    },
    lxFooterSocialLinksFacebook() {
        return Localization.get('badoo_safety_center@footer.social_links.facebook');
    },
    lxFooterSocialLinksTwitter() {
        return Localization.get('badoo_safety_center@footer.social_links.twitter');
    },

    lxFooterLegalLinksTerms() {
        return Localization.get('badoo_safety_center@footer.legal_links.terms');
    },
    lxFooterLegalLinksPrivacy() {
        return Localization.get('badoo_safety_center@footer.legal_links.privacy');
    },
    lxFooterLegalLinksCookiePolicy() {
        return Localization.get('bumblesite@LAYOUT.FOOTER.MANAGE_COOKIES');
    },
    lxFooterLegalLinksHelp() {
        return Localization.get('badoo_safety_center@footer.legal_links.help');
    },
    lxFooterLegalLinksPress() {
        return Localization.get('badoo_safety_center@footer.legal_links.press');
    },
    lxFooterCtaGetTheApp() {
        return Localization.get('badoo_safety_center@footer.cta.get_the_app');
    },
    lxFooterCtaAppStore() {
        return Localization.get('badoo_safety_center@store.app-store.a11y.label');
    },
    lxFooterCtaGooglePlay() {
        return Localization.get('badoo_safety_center@store.google-play.a11y.label');
    },
    lxFooterCopyright(params: { current_year: string }) {
        return Localization.get('badoo_safety_center@footer.copyright', params);
    },
    lxFooterLogoTitle(params: { page_parter_name: string }) {
        return Localization.get('badoo_safety_center@footer.logo.title', params);
    },
    lxFooterLogoA11yLabel(params: { partner: string }) {
        return Localization.get('badoo_safety_center@footer.logo.a11y.label', params);
    },
    lxLanguageSelection() {
        return Localization.get('badoo_homepage@footer.language_selector.a11y.label');
    },
    lxFooterA11yHeading() {
        return Localization.get('badoo_safety_center@footer.a11y.heading');
    },
};
